import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { User } from "../types/interfaces";

export const useToken = () => {
  const getToken = () => {
    const jwtToken = localStorage.getItem("token")! as string;
    const userToken = JSON.parse(jwtToken);
    return userToken;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken: string) => {
    localStorage.setItem("token", JSON.stringify(userToken));
    setToken(userToken);
  };

  const removeToken = () => {
    localStorage.removeItem("token");
    setToken("");
  };

  const getUserDetails = (): User | null => {
    try {
      const userToken = getToken();
      const userDetails: any = jwtDecode(userToken);
      return userDetails;
    } catch (e) {
      return null;
    }
  };

  return {
    token,
    setToken: saveToken,
    removeToken,
    user: getUserDetails(),
  };
};

export const useOnClickOutside = <T extends HTMLElement>(
  ref: React.RefObject<T>,
  handler: (event: MouseEvent) => void
) => {
  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
